<template>
<div id="statistics">
  <v-dialog transition="dialog-bottom-transition" hide-overlay fullscreen v-model="dialog" persistent max-width="290">
    <template v-slot:activator="{ on }">
      <v-btn color="primary" dark v-on="on">{{$t('stats.create')}}</v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">
        <v-toolbar flat dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{$t('stats.create')}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <Create :schemas="schemas"></Create>
      </v-card-text>
    </v-card>
  </v-dialog>

  <EditView v-on:closeFullView="closeFullView()" v-on:update="update($event)" :formData="itemView" :schemas="schemas" :edit="edit" :dialog="fullView" v-if="fullView"></EditView>

  <v-data-table :headers="headers" :items="formules" hide-actions class="elevation-1">
    <template slot="items" slot-scope="props">
      <td>{{ props.item.id }}</td>
      <td class="text-xs">{{ props.item.name }}</td>
      <td class="text-xs">{{ props.item.formule.substring(0,15) }}...</td>
      <td class="text-xs">{{ props.item.schema_id}}</td>
      <td class="text-xs">{{ props.item.type}}</td>
      <td class="text-xs">{{ props.item.created_at}}</td>
      <td class="layout px-0">
        <v-btn icon class="mx-0" @click="showItem(props.item)">
          <v-icon color="green darken-3">pageview</v-icon>
        </v-btn>
        <v-btn icon class="mx-0" @click="editItem(props.item)">
          <v-icon color="blue">edit</v-icon>
        </v-btn>
        <v-btn icon class="mx-0" @click="deleteFormule(props.item)">
          <v-icon color="orange">delete</v-icon>
        </v-btn>
      </td>
    </template>
    <template slot="no-data">
      <v-btn color="primary" @click="loadStatsFormule()">Reset</v-btn>
    </template>
  </v-data-table>


</div>
</template>

<script>
import http from '@/plugins/http'
import Create from './Create'
import EditView from './EditView'
import View from "../form/ViewDocumentForms";
export default {
  components: {
    View,
    Create,
    EditView
  },
  data() {
    return {
      basicValid: false,
      loading: false,
      dialog: false,
      fullView: false,
      edit: false,
      itemView: {},
      form: {},
      schemas: [],
      formules: [],
      headers: [{
          text: this.$t('base.id'),
          value: "id",
          align: "left"
        },
        {
          text: this.$t('stats.name'),
          value: "name",
          align: "left"
        },
        {
          text: this.$t('stats.formule'),
          value: "formule",
          align: "left"
        },
        {
          text: this.$t('stats.schema'),
          value: "schema_id",
          align: "left"
        },
        {
          text: this.$t('stats.type'),
          value: "type",
          align: "left"
        },
        {
          text: this.$t('stats.created_at'),
          value: "created_ad",
          align: "left"
        },
      ]
    }
  },
  computed: {
    status() {
      return [{
        "name": this.$t('inactive'),
        "value": 0
      }, {
        "name": this.$t('active'),
        "value": 10
      }]
    }
  },
  methods: {
    showItem(item) {
      this.itemView = item
      this.fullView = true
    },
    editItem(item) {
      this.edit = true
      this.showItem(item)
    },
    closeFullView() {
      this.fullView = false
      this.edit = false
    },
    update(model) {
      let data = {
        'formule': model.formule,
        'type': model.type,
        'schema_id': model.schema_id,
        'name': model.name
      }

      http.put('statistics/' + model.id, data).then(res => {
        this.formules = this.formules.map(v => v.id != model.id ? v : model)
        this.$store.commit("setSnack", {
          message: this.$t('stats.messages.update_success'),
          color: "success"
        })

        this.closeFullView()
      }).catch(() => {
        this.$store.commit("setSnack", {
          message: this.$t('stats.messages.update_error'),
          color: "danger"
        })
      })
    },
    loadSchemas() {
      this.loading = true
      http.get('schemas')
        .then(response => {
          this.schemas = response.data
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    },
    loadStatsFormule() {
      this.loading = true
      http.get('statistics/formules')
        .then(response => {
          this.formules = response.data
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    },
    deleteFormule(item) {
      http.delete('statistics/' + item.id).then(() => this.formules = this.formules.filter((el) => el.id != item.id))
    }
  },
  created() {
    this.loadSchemas()
    this.loadStatsFormule();
  }
}
</script>

<style>

</style>
